import { IconType } from './types';

export const PaperIcon = ({ size = 24, color = 'black' }: IconType) => (
  <svg width={size} height={size} fill="none" viewBox="0 -0.5 25 25">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.5 5h-5a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h5a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4Z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      d="M16 9.75a.75.75 0 0 0 0-1.5v1.5Zm-6-1.5a.75.75 0 0 0 0 1.5v-1.5Zm6 4.5a.75.75 0 0 0 0-1.5v1.5Zm-6-1.5a.75.75 0 0 0 0 1.5v-1.5Zm3 4.5a.75.75 0 0 0 0-1.5v1.5Zm-3-1.5a.75.75 0 0 0 0 1.5v-1.5Zm6-6h-6v1.5h6v-1.5Zm0 3h-6v1.5h6v-1.5Zm-3 3h-3v1.5h3v-1.5Z"
    />
  </svg>
);
